import { Grid, useMediaQuery } from "@mui/material";
import { useRecordContext } from "react-admin";

import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";
import { erasmusRequests } from "api/erasmusApi";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import { ErasmusInternshipDocuments } from "utils/constants";
import CertificateOfArrivalButton from "../../Partials/CertificateOfArrivalButton";
import GenerateDocumentButton from "../../Partials/GenerateDocumentButton";

const DocumentGenerationSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();

  const status = record?.userInfo?.internshipStatus;
  const available = ErasmusInternshipDocuments.filter(item => item.statuses.includes(status));

  if (!available.length) return null;

  return (
    <SecuredComponent permission={permissions.canManageIncomingInternshipStudentsCoordinator}>
      <SectionTitle
        paddingY={2}
        title="Генериране на документи"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        {available.map(({ label, path, advancesStatus, requiresForm }) => (
          <Grid
            item
            xs={12}
            md="auto"
            key={path}
          >
            {requiresForm ? (
              <CertificateOfArrivalButton
                buildUrl={params => erasmusRequests.getIncomingInternshipCertificateOfArrival(record.id, params)}
                fileName={path}
                label={label}
              />
            ) : (
              <GenerateDocumentButton
                url={erasmusRequests.getIncomingInternshipDocument(record.id, path)}
                fileName={path}
                label={label}
                refreshAfter={advancesStatus}
              />
            )}
          </Grid>
        ))}
      </Grid>
    </SecuredComponent>
  );
};

export default DocumentGenerationSection;
